<template>
<div id="removeclass">
   <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    modal-size="fullscreen"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">{{ $t("Form Builder") }}</h5>
      <!-- <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        @click="closeModal"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button> -->
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        {{ $t("close") }}
      </button>
    </template>
    <template slot="body">
      <div class="row">
        <div class="col-sm-12">
          <!-- <dynamic-form :id="id" :type="type" :tableId="tableId" :closemodal="closeModal"></dynamic-form> -->
          <div v-if="active != 1" class="mb-2">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item v-if="active < 4"> <a href="" @click.prevent="previous">List</a></el-breadcrumb-item>
              <el-breadcrumb-item v-if="active == 2">Edit</el-breadcrumb-item>
              <el-breadcrumb-item v-if="active == 3">View</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <el-form v-if="active === 1">
            <div class="row">
              <div class="col-sm-12 col-md-12 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <button
                      type="button"
                      class="btn btn-primary btn-sm"
                      data-toggle="modal"
                      @click="instructionOpen">
                      <!-- {{ $t("instruction") }} -->
                      <app-icon name="book-open" />
                    </button>
                </div>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="instructionShow == true">
                <div class="alert alert-info" role="alert">
                  <button type="button" class="close" @click.prevent="instructionClose">
                    <h5 aria-hidden="true">&times;</h5>
                  </button>
                  <!-- <hr> -->
                  <h5 class="alert-heading"><app-icon name="book-open" /> {{$t("instructions_about_form_body")}}</h5>
                  <p class="mb-0">{{myform == '' ? $t("introduction_form_body_list") : $t("introduction_form_body")}}</p>
                  <strong>Actions:</strong>
                  <ul>
                    <li v-if="myform != ''"><strong>{{ $t("edit") }} :</strong> {{ $t("edit_form_body_action") }}</li>
                    <li><strong>{{ $t("view") }} :</strong> {{ $t("view_form_body_action") }}</li>
                    <li v-if="myform == ''"><strong>{{ $t("import") }} :</strong> {{ $t("import_form_body_action") }}</li>
                    <li v-if="myform != ''"><strong>{{ $t("save_response") }} :</strong> {{ $t("save_response_form_body_action") }}</li>
                    <li v-if="myform != ''"><strong>{{ $t("delete") }} :</strong> {{ $t("delete_form_body_action") }}</li>

                  </ul>
                </div>
              </div>
            </div>
            <app-table
            :id="tableId"
            :options="options"
            @action="getListAction"/>
          </el-form>
          <el-form v-if="active === 2">
            <div class="row">
              <div class="col-sm-12 col-md-12 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    data-toggle="modal"
                    @click="instructionOpen">
                    <app-icon name="book-open" />
                  </button>
                </div>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="instructionShow == true">
                <div class="alert alert-info" role="alert">
                  <button type="button" class="close" @click.prevent="instructionClose">
                    <h5 aria-hidden="true">&times;</h5>
                  </button>
                  <h5 class="alert-heading"><app-icon name="book-open" /> {{$t("instructions_about_form_body_create")}}</h5>
                  <p class="mb-0">{{$t("instructions_form_body_create")}}</p>
                  <strong>Actions:</strong>
                  <ul>
                    <li><strong>{{ $t("save_form") }} :</strong> {{ $t("save_form_action") }}</li>
                  </ul>
                  <strong>{{$t("body_styling")}}</strong>
                  <h5 class="alert-heading mt-3"><app-icon name="book-open" /> {{$t("instructions_about_form_body_styling")}}</h5>
                  <p class="mb-0">{{$t("introduction_form_body_styling")}}</p>
                  <strong>Actions:</strong>
                  <ul>
                    <li><strong>{{ $t("previous") }} :</strong> {{ $t("previous_action") }}</li>
                    <li><strong>{{ $t("save_styling") }} :</strong> {{ $t("save_styling_action") }}</li>
                  </ul>
                </div>
              </div>
              <!-- <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="instructionShow == true && formType == ''">
                <div class="alert alert-info" role="alert">
                  <button type="button" class="close" @click.prevent="instructionClose">
                    <h5 aria-hidden="true">&times;</h5>
                  </button>
                  <h5 class="alert-heading"><app-icon name="book-open" /> {{$t("instructions_about_form_body_styling")}}</h5>
                  <p class="mb-0">{{$t("introduction_form_body_styling")}}</p>
                  <strong>Actions:</strong>
                  <ul>
                    <li><strong>{{ $t("previous") }} :</strong> {{ $t("previous_action") }}</li>
                    <li><strong>{{ $t("save_styling") }} :</strong> {{ $t("save_styling_action") }}</li>
                  </ul>
                </div>
              </div> -->
            </div>
            <div class="row">
              <div class="col-sm-12">
                <dynamic-form :id="formID" :newVersion='newVersion' :backList="previous" :formRevisionId="formRevisionId" :type="formType"></dynamic-form>
              </div>
            </div>
          </el-form>
          <el-form v-if="active === 3">
            
            <div class="row">
              <div class="col-sm-12">
                <form-preview :id="formBody" :form_revision_id="formRevisionId" :form_id="formID" :response="formType"></form-preview>
              </div>
            </div>
          </el-form>
        </div>
      </div>

      <!-- data table Start here -->
      <!-- <div class="mt-4">
        <app-table :id="tableId" />
      </div> -->
    </template>

    <!-- <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        {{ $t("close") }}
      </button>
    </template> -->
  </app-modal>
</div>
 
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper";
import * as actions from "../../../../Config/ApiUrl";
// import ThemeMixin from "../../../../../core/mixins/global/ThemeMixin";

export default {
  name: "FormBuilderModal",
  mixins: [FormMixin, ModalMixin, TableHelpers],
  props: {
    id: Number,
    type: String,
    myform: String,
  },
  data() {
    return {
      instructionShow: false,
      newVersion: '',
      formType: '',
      show: true,
      active: 1,
      formRevisionId: 0,
      formID: 0,
      formBody: 0,
      preloader: false,
      inputs: {
        yes: "no",
      },
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("form_bodies"),
      tableId: "advance-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: actions.FORM_BODIES+'/'+this.id+'?myform='+this.myform,
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
          // {
          //     title: this.$t('date'),
          //     type: 'media-object',
          //     key: 'media-object',
          //     mediaTitleKey: 'name',
          //     mediaSubtitleKey: 'email',
          //     default: AppFunction.getAppUrl('images/avatar-demo.jpg'),
          //     modifier: (value, row) => {
          //         return value; // imag url
          //     },
          //     isVisible: true
          // },
          {
            title: this.$t("name"),
            type: "custom-html",
            key: "get_forms",
            modifier: (value,row) => {
              return `<a href="#" id="${row.id+'_'+row.form_id+'_'+row.form_body_id}"  @click=${this.myFunction(row)}>${this.$t(value.name ?? "---")}</a>`;
            },
          },
          {
            title: this.$t("description"),
            type: "custom-html",
            key: "get_forms",
            modifier: (value) => {

              return `<span>${this.$t(value.description ?? "---")}</span>`;
            },
          },
          {
            title: this.$t("created_by"),
            type: "custom-html",
            key: "get_bodies",
            modifier: (value) => {
              
              let now = new Date();
              var date = moment(value.created_at ?? now).format("YYYY-MM-DD");
              return `<span> ${this.$t(value != null  ? value.created_by != null ? value.created_by.full_name : '---' : '---')}  </span> <br> <span> ${this.$t(date)}  </span>`;
            },
          },
          {
            title: this.$t("updated_by"),
            type: "custom-html",
            key: "get_bodies",
            modifier: (value) => {
              let now = new Date();
              var date = moment(value.updated_at ?? now).format("YYYY-MM-DD");
              return `<span> ${this.$t(value!= null ? value.updated_by != null ? value.updated_by.full_name : '---' : '---')}  </span> <br> <span> ${this.$t(date)}  </span>`;            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "active",
            isVisible: true,
            modifier: (value) => {
              let ClassName = "danger";
              let text;

              if (value == 1) 
              {
                ClassName = `success`;
                text = `Active`;
              }
              else 
              {
                text = `Inactive`;
              }

              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                text
              )}</span>`;
            },
          },
          {
            title: this.$t("version"),
            type: "custom-html",
            key: "version",
            modifier: (value) => {

              return `<span>${this.$t(value.toString() == '1' ? '1.0' : value.toString())}</span>`;
            },
          },
          // {
          //   title: this.$t("status"),
          //   type: "custom-html",
          //   key: "form_body_status",
          //   isVisible: true,
          //   modifier: (value) => {
          //     let ClassName = "danger";
          //     let text;

          //     if (value == this.userRole.id) 
          //     {
          //       ClassName = `success`;
          //       text = `My Document`;
          //     }
          //     else 
          //     {
          //       text = `Select Document`;
          //     }

          //     return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
          //       text
          //     )}</span>`;
          //   },
          // },
        ],
        actions: [
          // {
          //   title: this.$t("edit"),
          //   icon: "edit",
          //   type: "none",
          // },
          // {
          //   title: this.$t("view"),
          //   icon: "eye",
          //   type: "none",
          // },
          // {
          //   title: this.$t("import"),
          //   icon: "share",
          //   type: "none",
          // },
          // {
          //   title: this.$t("save_response"),
          //   icon: "share",
          //   type: "none",
          // },
          // {
          //   title: this.$t("delete"),
          //   icon: "trash",
          //   type: "none",
          // },
        ],
        filters: [
          {
            title: this.$t("date"),
            type: "range-picker",
            key: "date",
            option: ["today", "thisMonth", "last7Days", "nextYear"],
          },
          // {
          //   title: this.$t("age"),
          //   type: "range-filter",
          //   key: "age-range",
          //   maxTitle: this.$t("max_age"),
          //   minTitle: this.$t("min_age"),
          //   sign: "",
          // },
          {
            title: this.$t("documents"),
            type: "radio",
            key: "document_result",
            option: [
              { id: "1", value: "Folders" },
              { id: "0", value: "Files" },
            ],
            header: {
              title: this.$t("want_to_filter_your_list"),
              description: this.$t(
                "you_can_filter_your_data_table_which_are_created_based_on_gender"
              ),
            },
          },
          {
            title: this.$t("search_and_select"),
            type: "drop-down-filter",
            key: "search select",
            option: [],
          },
          {
            title: this.$t("my_document"),
            type: "checkbox",
            key: "document_type",
            option: [
              { id: "my_doc", value: "My Document" },
            ],
          },
        ],
        showFilter: false,
        showSearch: false,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    // this.preloader = true;
  },
  methods: {
    instructionOpen() {
      this.instructionShow = true;
    },
    instructionClose() {
      this.instructionShow = false;
    },

    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title === this.$t("edit") && (rowData.created_by === this.userRole.id )) {

        this.formType = rowData.get_forms.owner_id == this.userRole.id ? this.type : '';
        
        this.newVersion = '',
        this.formID = rowData.form_id;
        this.formRevisionId = rowData.id;
        this.active = 2;
      } else if (actionObj.title == this.$t("view")) {
        // this.formID = rowData.form_id;
        this.view(rowData);
      } 
      else if (actionObj.title == this.$t("import") && rowData.created_by != this.userRole.id) {
        this.formSeletion(rowData.id,rowData.form_id,rowData.form_body_id);
      } else if (actionObj.title == this.$t("delete") && rowData.created_by == this.userRole.id) {
          this.formRevisionId = rowData.id;
          this.deleteFormbody(this.formRevisionId);
      } else if (actionObj.title == this.$t("save_response") && rowData.created_by == this.userRole.id) {

          if (rowData.self == 1) {
              this.formType = 'save_response';
              this.formBody = rowData.form_body_id;
              this.formRevisionId = rowData.id;
              this.formID = rowData.form_id;
              this.active = 3;
          }
          else {
            this.updateFormRevision(rowData);
          }
      }
      else {
        this.$toastr.w('You can not use this action for this document');
      }
      // else if (actionObj.title == this.$t("view")) {
      //   window.location = "/admin/documentlibrary/report";
      // }
    },
    view(rowData) {
      this.formType = 'view';
      this.formBody = rowData.form_body_id;
      this.formRevisionId = rowData.id;
      this.active = 3;
    },
    myFunction(rowData){
      let doc = document.getElementById(rowData.id+'_'+rowData.form_id+'_'+rowData.form_body_id);
      if(doc){
        doc.addEventListener('click', () => {
          this.view(rowData);
        }) 
      }
    },
  
    updateFormRevision(rowData) {
      axiosGet(actions.UPDATE_FORM_REVISION_SELF +'/'+ rowData.id)
        .then((res) => {
          if (res.data.type == 'success') {
              this.formType = 'save_response';
              this.formBody = rowData.form_body_id;
              this.formRevisionId = rowData.id;
              this.formID = rowData.form_id;
              this.active = 3;
          }
        })
        .catch((error) => {
          
        });
    },
    formSeletion(form_revision_id,form_id,form_body_id) {

      let data = {
        form_revision_id: form_revision_id,
        form_id: form_id,
        form_body_id: form_body_id,
      };
      axiosPost(actions.SELECTED_FORM_STORE, data)
          .then((res) => {
            this.$toastr.s(res.data.message);
          })
          .catch((res) => {
            
            this.$toastr.e(res.data.message);
          })
          .finally(() => {
            this.$hub.$emit("reload-" + this.tableId);
          });
    },
    previous() {
        this.active = 1;
    },
    checkBodies() {
      axiosGet(actions.FORM_BODIES_COUNT+'/'+this.id)
        .then((res) => {
          
          if (res.data.form_body_id == null && res.data.created_by == this.userRole.id) {
            this.show = false;
            this.formID = this.id;
            this.formType = this.type;
            this.newVersion = 'new_version';
            this.active = 2;
          }
        })
        .catch((error) => {
          
        });
    },
    deleteFormbody(formRevisionId) {
      if (confirm("Are you sure you want to delete!")) {
        axiosGet(actions.DELETE_FORM_BODY+'/'+formRevisionId)
        .then((res) => {
            this.$toastr.s(res.data.message);
            this.$hub.$emit("reload-" + this.tableId);
        })
        .catch((error) => {
          
        });
      }
    }
  },
  mounted() {
    this.checkBodies();
    // $(function () {
    //   $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    // });
    if (this.myform == '') {
        this.options.actions = [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
          },
          {
            title: this.$t("import"),
            icon: "share",
            type: "none",
          },
      ]
    }
    else {
      this.options.actions = [    
        {
          title: this.$t("edit"),
          icon: "edit",
          type: "none",
        },
        {
          title: this.$t("view"),
          icon: "eye",
          type: "none",
        },
        {
          title: this.$t("save_response"),
          icon: "share",
          type: "none",
        },
        {
          title: this.$t("delete"),
          icon: "trash",
          type: "none",
        },
      ]
    }
  }, 
   computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
    theemMode() {
      return this.$store.state.theme;
    },
  }
};
</script>
